import { SecureStateType } from '../../constants/enums'
import { filterAndReplaceBadWords } from '../../utilities/ageGate'
import { useSecureState } from './useSecureState'

interface BadWordFilterProps {
    topic?: string
    username?: string
    messageText?: string
    replaceWith?: string
}

interface BadWordFilterResults extends BadWordFilterProps {
    ageGateActive: boolean
}

function useBadWordFilter(props: BadWordFilterProps): BadWordFilterResults {
    const { messageText, topic, username, replaceWith } = props
    const { ageGateActive } = useSecureState(SecureStateType.AGE_VERIFICATION)
    const filteredWords: BadWordFilterResults = {
        ageGateActive,
        ...(topic
            ? { topic: ageGateActive ? filterAndReplaceBadWords(topic) : topic }
            : {}),
        ...(messageText
            ? {
                  messageText: ageGateActive
                      ? filterAndReplaceBadWords(messageText)
                      : messageText,
              }
            : {}),
        ...(username
            ? {
                  username: ageGateActive
                      ? filterAndReplaceBadWords(username, replaceWith)
                      : username,
              }
            : {}),
    }

    return filteredWords
}

export default useBadWordFilter
